
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M8 16.5v3h8v-5H8v2zm1-1h6v1H9v-1zm0 2h6v1H9v-1zM16 7.5v-3H8v5h8z"}}),_c('path',{attrs:{"d":"M18 7.5h-1v3H7v-3H6c-1 0-2 1-2 2v5c0 1 1 2 2 2h1v-3h10v3h1c1 0 2-1 2-2v-5c0-1-1-2-2-2z"}})])])
          )
        }
      }
    